import React from 'react';
import Label from './Label';
import Description from './Description';
import Errors from './Errors';
import { useIntl } from 'hooks';

interface Props {
  label?: React.ReactNode;
  required?: boolean;
  name?: string;
  errors?: string | string[] | null;
  description?: string;
  children: React.ReactNode;
}

export default function Field(props: Props) {
  const { label, required, name, errors, description, children } = props;
  const { t } = useIntl();
  return (
    <div className="mb-3 last:mb-0">
      {(!!label || !!description) && (
        <div className="mb-1">
          {!!label && (
            <Label name={name}>
              {label}
              {!required && (
                <span className="font-normal"> ({t('Form__Optional')})</span>
              )}
            </Label>
          )}

          {!!description && <Description>{description}</Description>}
        </div>
      )}

      {children}

      {!!errors?.length && <Errors errors={errors} />}
    </div>
  );
}
